export enum InputGroupTypes {
    Currency = "$",
    Percentage = "%"
}